var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Layer",
    width: 77.917,
    height: 77.917,
    viewBox: "0 0 77.917 77.917",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:#17d66f;fill-rule:evenodd}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trazado_74",
    d: "M49.605 9.1a3.542 3.542 0 0 1-.248 4.852l-26 24.331a4.215 4.215 0 0 1-5.879-.354l-10.621-9.49a3.55 3.55 0 1 1 4.71-5.312l9.456 8L44.682 8.818a3.542 3.542 0 0 1 4.923.282z",
    className: "prefix__cls-1",
    "data-name": "Trazado 74",
    transform: "translate(10.851 16.682)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trazado_75",
    d: "M39.958 8.083a31.875 31.875 0 1 0 31.875 31.875A31.875 31.875 0 0 0 39.958 8.083zM1 39.958a38.958 38.958 0 1 1 38.958 38.959A38.958 38.958 0 0 1 1 39.958z",
    className: "prefix__cls-1",
    "data-name": "Trazado 75",
    transform: "translate(-1 -1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.5fb682c2719cd0410f2c5892f248114d.svg";
export { ForwardRef as ReactComponent };